import Home from "./home";

function NativeAppPage() {
  return <Home />;
}

export default NativeAppPage;
